<template>
    <div>
        <div id="tags">
            <span class="tag" v-for="(tag, index) in tags" :key="index">
                {{tag}}
                <span class="fa-stack fa-1x close-button" @click="deleteTag(index)">
                    <i class="fa fa-circle fa-stack-2x"></i>
                    <i class="fa fa-close fa-stack-1x fa-inverse"></i>
                </span>
            </span>
        </div>
        <input class="input" type="text" :placeholder="placeholder" v-model="input" @keyup="addTag($event.code)"/>
    </div>
</template>

<script>
export default {
  name: 'tagInput',
  props: ['placeholder', 'checkFormat', 'inputTags'],
  components: {},
  created () {},
  data () {
    return {
      input: '',
      tags: []
    }
  },
  watch: {
    inputTags () {
      if (this.inputTags) {
        this.tags = this.inputTags
      } else {
        this.tags = []
      }
    }
  },
  methods: {
    addTag (code) {
      if (code === 'Comma' || code === 'Space' || code === 'Enter') {
        var regex = new RegExp(/([A-Z]{4})([ -]?)(\d{6}-?\d)/g)
        var inputTags = this.input.match(regex) // Separates tags bt regrex
        if (!this.checkFormat) {
          inputTags = this.input.split(' ') // Separates tags by space
        }
        if (inputTags) {
          inputTags.forEach((tag) => {
            if (this.input.indexOf(tag + ' ') >= 0) {
              this.input = this.input.replace(tag + ' ', '')
            } else {
              this.input = this.input.replace(tag, '')
            }
            if (tag !== '' && this.tags.indexOf(tag.replace(' ', '')) < 0) {
              this.tags.push(tag.replace(' ', '').replace(';', '').replace(',', ''))
            }
          })
          this.$emit('updated', this.tags)
        } else {
          this.$notify({group: 'global', type: 'error', duration: 4000, title: 'ERROR', text: 'Container numbers feature 4 uppercase letters followed by 7 digits'})
        }
      }
    },
    deleteTag (index) {
      this.tags.splice(index, 1)
      this.$emit('updated', this.tags)
    }
  }
}
</script>
<style lang="scss" scoped>
    .tag{
      text-transform: uppercase;
      font-size: .9em;
      padding: .7em;
      padding-right: 0;
      margin: .3em;
      background:  white;
      border: 2px solid #009d97;
      margin-top: 0;
      border-radius: .3em;
      font-weight: bolder;

      .close-button {
          font-size: .8em;
          color: #009d97;
          margin-left: 1em;
          &:hover{
              color: #22BFB9
          }
      }
    }
</style>




// WEBPACK FOOTER //
// src/components/TagInput.vue